//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { ColumnModel } from '../../api/api.models'
import { LocalDictionaryFactory } from '../../api/api.module'

import { ConfigHelper, DataTypeGroupComponent, EventsNames, LocalizationHelper, OperatorLayoutSettings, TemplateHelper, TypeHelper, ToastHelper } from '../../../helpers/'


import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { LoggerService } from '../../common/common.module'
import { ItemSwapperPopupOptions, IItemSwapperPopup, ItemSwapperResult } from '../../../modules/common/item-swapper/'

import { Activity, Enums } from '../../../models/common/'
import { OpDataTypeInGroup, OpLocation } from '../../../models/core/'
import { SESSION } from '../../../models/custom/session'

import { UserSessionService } from '../../../services/user-session'
import { GroupingLocationService } from '../../../services/grouping-locations'
import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { ColumnInfo } from '../../../models/custom'


interface GroupingLocationDetailsScope extends DetailsScope {

    GROUPING_LOCATION_PARAMS_ACCORDION_NAME: string
    GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME: string
    GROUPING_LOCATION_COMMON_TAB_NAME: string

    id: number

    groupingLocationDetails: any

    assignedLocationsCount: number
    assignedLocationsGridOptions: GridOptions

    isAssignedLocationsItemSwapperPopupVisible: boolean
    itemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocation>

    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
}

export class GroupingLocationDetailsDirectiveController extends Details<GroupingLocationDetailsScope> {

    // #region Consts

    private get GROUPING_LOCATION_PARAMS_ACCORDION_NAME() { return 'GROUPING_LOCATION_PARAMS_ACCORDION_NAME' }
    private get GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME() { return 'GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME' }
    private get GROUPING_LOCATION_COMMON_TAB_NAME() { return 'GROUPING_LOCATION_COMMON_TAB_NAME' }

    // #endregion


    // #region Members

    private referenceObject: OpLocation
    private referenceObjectId: number

    private assignedLocationsGrid: GridController<OpLocation>

    private itemSwapperPopup: IItemSwapperPopup<OpLocation>

    // #endregion


    constructor(
        $scope: GroupingLocationDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        private groupingLocationService: GroupingLocationService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.LocationPopupTabActive, userSession, referenceType)

        this.setConfirmationsOptions()
        this.setEvents()
        this.setOptions()
        this.setTemplateConsts()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }


    // #region Events

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options

        this.referenceObjectId = options.referenceObjectId

        this.onClear()
        this.showPopup()
        this.onRefresh()
    }

    private onRefresh(toRefresh: OpLocation = null): void {
        const deferred: JQueryDeferred<OpLocation> = $.Deferred<OpLocation>()

        if (!toRefresh) {
            this.userSession
                .getDataProvider().Location
                .getLocation(this.referenceObjectId)
                .then((result: OpLocation) => {
                    deferred.resolve(result)
                })
                .fail((error: any) => {
                    let errorMsg: string = error

                    if (SESSION.isType(error)) {
                        errorMsg = (<SESSION>error).toString()
                    }

                    ToastHelper.showError(errorMsg|| LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))

                    this.logger.log(errorMsg)
                    deferred.resolve(null)
                })
                .always(() => {
                    this.$scope.showTabs = true
                })
        }
        else {
            deferred.resolve(toRefresh)
        }

        deferred
            .promise()
            .then((result: OpLocation) => {
                if (result && (!this.referenceObject || this.referenceObject.idLocation == result.idLocation)) {
                    this.referenceObject = result;

                    this.setBasicParameters();
                    this.setAssignedLocationsGrid();
                    this.initializeItemSwapper()
                }
            })
    }

    private onClear(): void {
        this.$scope.popupTitle = TypeHelper.emptyString
        this.$scope.showTabs = false

        this.referenceObject = null

        this.assignedLocationsGrid = null

        this.$scope.assignedLocationsCount = 0
        this.$scope.assignedLocationsGridOptions = null
    }

    private onClose(): void {
        this.$scope.assignedLocationsGridOptions = null

        this.hidePopup()
    }

    private onConfirmDelete(): void {
        this.groupingLocationService
            .deleteGroupingLocation(this.referenceObjectId)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
                this.onClose()
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onParamsEdit(): void {
        this.groupingLocationService
            .getCreateEditOptions(this.referenceObjectId, this.referenceObject)
            .then((createEditparams: CreateEditInitParams) => {
                this.$scope.$root.$broadcast(
                    EventsNames.INITIALIZE_CREATE_EDIT_POPUP,
                    createEditparams
                )
            })
    }

    // #endregion


    // #region Location Assignment

    private setItemSwapperLeftGridDataSource(): void {
        this.itemSwapperPopup.itemSwapper.reset()
    }

    private openRewarehousingItemSwapper() {
        this.setItemSwapperLeftGridDataSource()
        this.itemSwapperPopup.show()
    }

    private initializeItemSwapper(): void {
        this.groupingLocationService
            .getDefaultAssignedLocationsItemSwapperOptions(this.moduleName, this.referenceType)
            .then((options: ItemSwapperPopupOptions<OpLocation>) => {
                options.onSave = (result: ItemSwapperResult<OpLocation>) => this.onAssignedLocationsSave(result)

                options.itemSwapperOptions.rightGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.itemSwapperPopup != null && this.itemSwapperPopup.isVisible()) {
                        return this.userSession
                            .getDataProvider()
                            .Location
                            .getAllLocationFilter(columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                options.itemSwapperOptions.leftGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.itemSwapperPopup != null && this.itemSwapperPopup.isVisible()) {
                        return this.userSession
                            .getDataProvider()
                            .GroupingLocation
                            .getGroupingLocationAssignedLocationsPaginated(this.referenceObjectId, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                this.$scope.itemSwapperPopupOptions = options
                this.$scope.itemSwapperPopupOptions.onInitialized = (itemSwapper: IItemSwapperPopup<OpLocation>) => {
                    this.itemSwapperPopup = itemSwapper
                }
            })
    }

    private onAssignedLocationsSave(result: ItemSwapperResult<OpLocation>): JQueryPromise<any> {
        return this.groupingLocationService
            .assignGroupingLocation(this.referenceObjectId, result)
            .then(() => {
            })
            .fail((error: any) => {
                this.logger.log(error);
            })
            .always(() => {
                this.onRefresh(this.referenceObject)
            });
    }

    // #endregion


    // #region Setup

    public getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []
        let items: DetailsAccordionSection[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.GroupingLocationParameters)) {
            items.push({
                name: this.GROUPING_LOCATION_PARAMS_ACCORDION_NAME,
                showInTab: this.GROUPING_LOCATION_COMMON_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.GroupingLocationParameters),

                editMethod: () => this.onParamsEdit(),
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 0, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.GroupingLocationAssignedLocations)) {
            items = []

            items.push({
                name: this.GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME,
                showInTab: this.GROUPING_LOCATION_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedLocations),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.GroupingLocationAssignedLocations),

                editMethod: () => this.openRewarehousingItemSwapper(),
                status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + this.$scope.assignedLocationsCount,
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.LocationAccordionsSettings, 1, items))
        }

        return accordions
    }

    public getTabs(): any[] {
        return [{
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),

            name: this.GROUPING_LOCATION_COMMON_TAB_NAME
        }]
    }

    private setAssignedLocationsGrid(): void {
        if (this.$scope.assignedLocationsGridOptions != null && this.assignedLocationsGrid != null) {
            this.assignedLocationsGrid.refresh()
            return;
        }

        this.userSession
            .getDataProvider().System
            .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ASSIGNED_LOCATION_GRID_PARAMS, this.moduleName)
            .then((columns: ColumnModel[]) => {
                this.$scope.assignedLocationsGridOptions = {
                    addCustomFilters: true,
                    columnsDictionary: columns,
                    name: 'GroupingLocationAssignedLocationsGrid',
                    type: GridTypes.PAGINATED_SMALL,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.GroupingLocationAssignedLocations),

                    buttonsOptions: {
                        enabled: true,
                    },

                    getDataSourceMethod: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                        return this.userSession
                            .getDataProvider()
                            .GroupingLocation
                            .getGroupingLocationAssignedLocationsPaginated(this.referenceObjectId, columns, pageNbr, pageSize, customWhereClause)
                            .then((result: any) => {
                                if (result != null && _.isNumber(result.totalCount)) {
                                    this.$scope.assignedLocationsCount = result.totalCount
                                }

                                return result
                            })
                    },

                    onInitialized: (e: any, grid: GridController<OpLocation>) => {
                        this.assignedLocationsGrid = grid
                    },

                    onDataReady: (locations: OpLocation[]) => {

                    }
                }
            })
    }

    private setBasicParameters(): void {
        DataTypeGroupComponent
            .getDataTypeInGroupByModule(
                this.userSession.getDataProvider(),
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY,
                this.moduleName,
                Enums.ReferenceType.IdDistributor,
                this.userSession.getLoggedOperator().idDistributor
            )
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.$scope.groupingLocationDetails = this.referenceObject ? Details.filterDynamicValues(this.referenceObject, dataTypeInGroup) : []
            })
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))
    }

    private setOptions(): void {
        this.accordionsNameToShow = this.GROUPING_LOCATION_COMMON_TAB_NAME

        this.$scope.popupTitle = TypeHelper.emptyString
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DEL) ? Activity[Activity.GROUPING_LOCATION_DEL] : null,
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => this.onDelete(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => this.updateAccordions(names)
        }
    }

    private setTemplateConsts(): void {
        this.$scope.GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME = this.GROUPING_LOCATION_ASSIGNED_LOCATIONS_ACCORDION_NAME
        this.$scope.GROUPING_LOCATION_COMMON_TAB_NAME = this.GROUPING_LOCATION_COMMON_TAB_NAME
        this.$scope.GROUPING_LOCATION_PARAMS_ACCORDION_NAME = this.GROUPING_LOCATION_PARAMS_ACCORDION_NAME
    }

    // #endregion

    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(null) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}